module.exports = __webpack_public_path__ + "static/media/LambdaSchoolLogo.971ee82b.png";